// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_no_","cls2":"LoswpTabsHero-cls2_4Zo LoswpTabsHero-cls1_no_"};